import { render, staticRenderFns } from "./AlarmTabPane.vue?vue&type=template&id=3d06e21b&scoped=true"
import script from "./AlarmTabPane.vue?vue&type=script&lang=js"
export * from "./AlarmTabPane.vue?vue&type=script&lang=js"
import style0 from "./AlarmTabPane.vue?vue&type=style&index=0&id=3d06e21b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d06e21b",
  null
  
)

export default component.exports